const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

const getHeaders = () => {
  const token = localStorage.getItem("token");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  return {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
};

// Get all pending project requests
export const getPendingProjects = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/pending-projects/`,
      {
        method: "GET",
        headers: getHeaders(),
      }
    );

    const data = await response.json();

    if (response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("refresh");
      localStorage.removeItem("user");
      window.location.href = "/";
      throw new Error("Session expired. Please login again.");
    }

    if (!response.ok) {
      throw new Error(
        data.error || "Failed to fetch pending projects"
      );
    }

    return data;
  } catch (error) {
    console.error("Error fetching pending projects:", error);
    throw error;
  }
};

// Approve project
export const approveProject = async (projectId) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/approve_project/${projectId}/`,
      {
        method: "POST",
        headers: getHeaders(),
      }
    );

    const data = await response.json();

    if (response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("refresh");
      localStorage.removeItem("user");
      window.location.href = "/";
      throw new Error("Session expired. Please login again.");
    }

    if (!response.ok) {
      throw new Error(
        data.error || "Failed to approve project"
      );
    }

    return data;
  } catch (error) {
    console.error("Error approving project:", error);
    throw error;
  }
};